import { render, staticRenderFns } from "./PatientCareTable.vue?vue&type=template&id=6c5e2b24&scoped=true&"
import script from "./PatientCareTable.vue?vue&type=script&lang=js&"
export * from "./PatientCareTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e2b24",
  null
  
)

export default component.exports